import { create } from 'zustand';

/**
 * Store quản lý dữ liệu tin tức
 * Bao gồm: danh sách tin tức, phân trang, bộ lọc, trạng thái loading
 */
export const useNewsStore = create((set, get) => ({
    // State - Trạng thái dữ liệu
    news: [],               // Danh sách tin tức hiện tại
    pageIndex: 1,          // Trang hiện tại
    hasMore: true,          // Còn dữ liệu để load thêm không
    totalItems: 0,          // Tổng số items
    isLoading: false,       // Trạng thái loading
    lastLoadTime: null,     // Thời gian load dữ liệu cuối cùng

    // Bộ lọc tìm kiếm
    filters: {
        keyword: '',        // Từ khóa tìm kiếm
        categoryId: '',     // ID danh mục được chọn
        locale: ''          // Ngôn ngữ hiện tại
    },

    // Actions - Các hành động cập nhật state

    // Cập nhật bộ lọc
    setFilters: (patch) => set(state => ({
        filters: { ...state.filters, ...patch }
    })),

    // Thiết lập danh sách tin tức mới (thay thế hoàn toàn)
    setNews: (items, total, page, pageSize = 10) => set(() => ({
        news: items || [],                              // Danh sách tin tức mới
        totalItems: total || 0,                         // Tổng số items
        pageIndex: page || 1,                          // Trang hiện tại
        hasMore: (page || 1) * pageSize < (total || 0), // Còn dữ liệu để load thêm
        isLoading: false,                              // Tắt loading
        lastLoadTime: Date.now()                       // Cập nhật thời gian load
    })),

    // Thêm tin tức vào danh sách hiện tại (load more)
    appendNews: (items, total, page, pageSize = 10) => set(state => ({
        news: [...state.news, ...(items || [])],       // Nối thêm vào danh sách cũ
        totalItems: total || state.totalItems,         // Cập nhật tổng số
        pageIndex: page || state.pageIndex,            // Cập nhật trang hiện tại
        hasMore: (page || state.pageIndex) * pageSize < (total || state.totalItems), // Kiểm tra còn dữ liệu
        isLoading: false,                              // Tắt loading
        lastLoadTime: Date.now()                       // Cập nhật thời gian load
    })),

    // Cập nhật trạng thái loading
    setLoading: (loading) => set({ isLoading: loading }),

    // Reset bộ lọc về trạng thái ban đầu
    resetFilters: () => set(state => ({
        filters: {
            keyword: '',                    // Xóa từ khóa
            categoryId: '',                // Xóa danh mục
            locale: state.filters.locale   // Giữ nguyên ngôn ngữ
        }
    })),

    // Kiểm tra có bộ lọc nào đang active không
    hasActiveFilters: () => {
        const state = get();
        return state.filters.keyword || state.filters.categoryId;
    },

    // Reset toàn bộ store về trạng thái ban đầu
    resetStore: () => set(() => ({
        news: [],
        pageIndex: 1,
        hasMore: true,
        totalItems: 0,
        isLoading: false,
        lastLoadTime: null,
        filters: {
            keyword: '',
            categoryId: '',
            locale: ''
        }
    }))
}));
